'use strict';

import React, { Component } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Tooltip, Icon } from './';

import '../../scss/components/_copy-icon.scss';

export default class CopyIcon extends Component {
	state = {
		hasCopiedText: false,
	};

	handleCopy = () => {
		this.setState({ hasCopiedText: true });
	};

	handleMouseOut = () => {
		this.setState({ hasCopiedText: false });
	};

	renderTooltipContent = () => {
		if (this.state.hasCopiedText) {
			return (
				<div className="tooltip-content">
					<img src="/assets/img/checkmark.svg" />
					<span className="tooltip-text">Copied to clipboard</span>
				</div>
			);
		}

		return this.props.text;
	};

	render() {
		return (
			<Tooltip style="icon" position="right" text={this.renderTooltipContent()}>
				<CopyToClipboard text={this.props.copyText} onCopy={this.handleCopy}>
					<Icon
						type="copy"
						className="copy-icon"
						onMouseOut={this.handleMouseOut}
						onClick={e => {
							e.preventDefault();
						}}
					/>
				</CopyToClipboard>
			</Tooltip>
		);
	}
}

CopyIcon.propTypes = {
	text: React.PropTypes.string,
	copyText: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/assets/js/components/CopyIcon.js